import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Mainmenu from '../../Shared/Mainmenu/Mainmenu';
import About from '../About/About';
import Banner from '../Banner/Banner';
import Projects from '../Projects/Projects';
import Reviews from '../Reviews/Reviews';

const Home = () => {
    return (
        <div>
            <Mainmenu/>
            <Banner/>
            <About/>
            <Projects/>
            <Reviews/>
            <Footer/>
        </div>
    );
};

export default Home;